import React from "react";
import ProjectView from "../component/project/ProjectView";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import themeLarge from "../component/ThemeLarge";
import Footer from "../component/Footer";
import { useParams } from "react-router-dom";
import LoadingLottie from "../component/Loading";

class Projects extends React.Component {
  constructor(props) {
    super(props);
    // Initialize the state
    this.state = {
      isMobile: window.innerWidth <= 768,
      allProjects: null,
    };
  }

  // This function will update windowSize in the state whenever the window is resized
  updateWindowSize = () => {
    this.setState({
      isMobile: window.innerWidth <= 768,
    });
  };

  // Add event listener when the component mounts
  componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
    this.updateWindowSize();
    this.fetchAllProjects().then(() => {
      if (this.props.slug) {
        this.scrollToProject(this.props.slug);
      }
    });
  }

  // Remove event listener when the component unmounts to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  isCacheExpired = (timestamp) => {
    const now = new Date();
    const cacheTime = new Date(timestamp);
    const diffInDays = (now - cacheTime) / (1000 * 60 * 60 * 24);
    return diffInDays > 30;
  };

  // Fetch raw projects from Firestore
  fetchProjectsFromFirestore = async () => {
    // const cachedData = localStorage.getItem("projects");
    // const cachedTime = localStorage.getItem("projects_lastUpdated");

    // if (cachedData && cachedTime && !this.isCacheExpired(cachedTime)) {
    //   return JSON.parse(cachedData);
    // }

    // ✅ Firestore query with filter: status == "published"
    const db = getFirestore();
    const q = query(
      collection(db, "projects"),
      where("status", "==", "published")
    );

    const querySnapshot = await getDocs(q);
    const projects = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    // Cache the result
    // localStorage.setItem("projects", JSON.stringify(projects));
    // localStorage.setItem("projects_lastUpdated", new Date().toISOString());

    return projects;
  };

  // Enrich projects with GitHub last commit info
  fetchLastCommitInfoForProjects = async (projects) => {
    const enrichedProjects = await Promise.all(
      projects.map(async (project) => {
        if (!project.github) return project;

        try {
          const urlParts = project.github.split("/");
          const owner = urlParts[3];
          const repo = urlParts[4];

          const res = await fetch(
            `https://api.github.com/repos/${owner}/${repo}/commits`
          );
          if (!res.ok) throw new Error("Failed to fetch commits");

          const data = await res.json();
          const commitDate = new Date(data[0].commit.author.date);
          const now = new Date();
          const diffTime = now - commitDate;
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
          const diffMonths = Math.floor(diffDays / 30);
          const diffYears = Math.floor(diffMonths / 12);

          let text;
          if (diffDays === 0) text = "Today";
          else if (diffDays === 1) text = "1 day ago";
          else if (diffDays < 30) text = `${diffDays} days ago`;
          else if (diffMonths === 1) text = "1 month ago";
          else if (diffMonths < 12) text = `${diffMonths} months ago`;
          else if (diffYears === 1) text = "1 year ago";
          else text = `${diffYears} years ago`;

          return {
            ...project,
            lastCommitText: text,
          };
        } catch (err) {
          return {
            ...project,
            lastCommitText: "Private or inaccessible repo",
          };
        }
      })
    );

    return enrichedProjects;
  };

  // Main call: fetch, enrich, sort, set
  fetchAllProjects = async () => {
    try {
      const rawProjects = await this.fetchProjectsFromFirestore();
      // const projectsWithCommits = await this.fetchLastCommitInfoForProjects(
      //   rawProjects
      // );

      this.setState({ allProjects: rawProjects });
    } catch (error) {
      console.error("Error fetching or processing projects:", error);
    }
  };

  scrollToProject = (slug) => {
    const el = document.getElementById(`project-${slug}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  render() {
    const { allProjects, isMobile } = this.state;

    return (
      <div style={{ marginTop: isMobile ? "0px" : "75px" }}>
        {allProjects ? (
          <ProjectView allProjects={allProjects} isMobile={isMobile} />
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minHeight: "80vh",
              flexDirection: "column",
              fontFamily: "Kumbh Sans",
              color: themeLarge.colors.text,
              marginTop: "50px",
            }}
          >
            {/* <div
              className="spinner-border text-primary"
              role="status"
              style={{
                width: "3rem",
                height: "3rem",
                color: themeLarge.colors.primary,
                borderColor: themeLarge.colors.primary,
                borderRightColor: "transparent",
              }}
            ></div> */}
            <LoadingLottie style={{ marginTop: "20px" }} />
          </div>
        )}

        <Footer />
      </div>
    );
  }
}

function ProjectsWithSlugWrapper(props) {
  const { slug } = useParams();
  return <Projects {...props} slug={slug} />;
}

export default ProjectsWithSlugWrapper;
